import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../../HTH";
import {HTHSound} from "../../sound/HTHSound";


export class DropInPresentation implements SimplePresentation {
    name: string = "DropInPresentation";

    shouldRun(): boolean {
        return !HTH.model.isCurrentAvalanche;
    }

    start(controller: SimplePresentationRunnerController): void {
        const dropInTl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.reelArea.allReels[5].reelView.stopScatterAnticipation();
                HTH.reelAnticipation.reset();
                HTH.reelArea.makeBlurFilterNull();
                controller.setSkipCallback();
                controller.finish();
            }
        });
        let presentationSkipped: boolean = false;
        dropInTl.add(() => controller.setSkipCallback(() => {
            dropInTl.seek("dropincomplete", false);
            presentationSkipped = true;

        }), 0.5);
        let padding: number = HTH.gameFlowController.calculatePaddingDuration(HTH.reelArea.DROP_IN_REEL_DELAY * 14);
        padding = (padding > 0 ? padding : 0);
        dropInTl.to(this, {duration: 0.2});
        dropInTl.add(HTH.reelArea.dropIn(padding), 0.2);
        dropInTl.add(() => {
            HTHSound.playTrack(HTHSound.REELS_SPIN_IN);
        }, "<");

        dropInTl.addLabel("dropincomplete");
        dropInTl.to(this, {duration: 0.001});
        if (HTH.model.nearWinReels.includes(true)) {
            dropInTl.add(HTH.reelArea.allReels[5].reelView.stopScatterAnticipation());
            dropInTl.add(() => {
                HTH.reelAnticipation.reset();
            });
        }
        dropInTl.add(() => {
            HTH.reelArea.ebSpinArea.isEnhancerSpinning = false;
            controller.setSkipCallback();
        });
        const containsSpecialSym: boolean = HTH.model.gameData.reels
            .reduce((a, b) => a.concat(b), [])
            .filter((item) => (!((item.includes("M") || item.includes("L") || item.includes("EB") || item.includes("SC") || item.includes("SA") || item === "X")))).length > 0;
        let landindAnimationCompleteTime: number;
        containsSpecialSym ? landindAnimationCompleteTime = HTH.reelArea.SPECIAL_SYMBOL_LANDIND_DELAY : landindAnimationCompleteTime = 0;
        dropInTl.to(this, {duration: landindAnimationCompleteTime});
        if (HTH.model.gameData.spinWin === 0 && !HTH.model.isCurrentAvalanche && HTH.autoPlayPlugin.isAutoplayRound && !containsSpecialSym) {
            dropInTl.to(this, {duration: 0.15}); // added to register time for no win round
        }

        /*    if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
                dropInTl.timeScale(1.4);
            }*/

    }
}